import type { JSX, SVGProps } from 'react';
export default function SvgCheckbox(props: SVGProps<SVGSVGElement>): JSX.Element {
    // ----------------------------------------------------------------------------------------------------
    // MARK: Main Component UI
    // ----------------------------------------------------------------------------------------------------
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" fill="currentColor" {...props}>
            <path d="M25.6 0c3.535 0 6.4 2.865 6.4 6.4v19.2c0 3.535-2.865 6.4-6.4 6.4h-19.2c-3.535 0-6.4-2.865-6.4-6.4v-19.2c0-3.535 2.865-6.4 6.4-6.4h19.2zM23.465 10.934c-0.478-0.478-1.253-0.478-1.731 0l-7.535 7.536-3.335-3.336c-0.478-0.478-1.253-0.478-1.731 0s-0.478 1.253 0 1.731l4.2 4.2c0.478 0.478 1.253 0.478 1.731 0l8.4-8.4c0.478-0.478 0.478-1.253 0-1.731z" />
        </svg>
    );
}
